<script>
import EntitiesTable from '$common/EntitiesTable'
export default {
  name: 'AdminGuardians',
  components: {
    'entities-table': EntitiesTable,
  },
  data () {
    return {
      guardians: [],
      locations: [],
      cells: [
        {
          name: 'Name',
          getInfo: guardian => guardian.name,
          sortFunc: (a, b) => a.name.localeCompare(b.name),
        },
        // {
        //   name: 'Location',
        //   getInfo: guardian => this.locations.find(location => location.id === guardian.location_id).display_name,
        //   sortFunc: (a, b) => a.location_id.localeCompare(b.location_id),
        // },
        {
          name: 'Application Status',
          getInfo: guardian => ({
            APPROVED: 'Approved for scholarship',
            APPROVED_NOT_PAID: 'Approved - not paid',
            FULLY_PAID: 'Paid in full',
            PENDING: 'Scholarship pending',
            OFFER_SENT: 'Different scholarship proposed',
            SCHOLARSHIP_REBUTTED: 'Guardian provided more info',
          })[guardian.application_status],
        },
        {
          name: 'Email',
          getInfo: guardian => guardian.email,
          sortFunc: (a, b) => a.email.localeCompare(b.email),
          style: {
            'word-break': 'break-all',
          },
          actionIcon: {
            icon: 'filter_none',
            action: () => {
              const guardianEmails = this.filteredGuardians.map(guardian => guardian.email)
              this.$copyToClipboard(guardianEmails.join('\n'))
              this.$toast('Copied guardian emails.')
            },
          },
        },
        {
          name: 'Phone',
          getInfo: guardian => guardian.phone,
          sortFunc: (a, b) => a.phone.localeCompare(b.phone),
          style: {
            'word-break': 'break-all',
          },
        },
        {
          name: 'Paperwork',
          getInfo: guardian => guardian.agreed_to_conduct_and_discipline_policy ? 'done' : 'highlight_off',
          classFunc: guardian => 'material-icons ' + (guardian.agreed_to_conduct_and_discipline_policy ? 'green-font' : 'red-font'),
          onClick: (guardian) => {
            if (guardian.agreed_to_conduct_and_discipline_policy) return this.$toast('Paperwork complete')
            this.$modals.show({
              name: 'paperwork',
              guardianId: guardian.id,
              onSuccess: this.getGuardians,
              hardClose: true,
            })
          },
        },
        {
          name: 'Edit Info',
          getInfo: () => 'Edit',
          classFunc: () => 'action-link',
          onClick: (guardian) => {
            this.$modals.show({
              name: 'create-guardian',
              onSuccess: this.getGuardians,
              info: guardian,
            })
          }
        },
        {
          name: 'Invoice',
          getInfo: () => 'email',
          classFunc: () => 'material-icons',
          onClick: (guardian) => {
            this.$modals.show({
              name: 'invoice',
              guardian: guardian,
            })
          }
        },
        {
          name: 'Reset Password',
          getInfo: () => 'email',
          classFunc: () => 'material-icons',
          onClick: (guardian) => {
            this.$modals.show({
              name: 'password-reset',
              email: guardian.email,
            })
          }
        },
      ],
      sorting: {
        ascending: true,
        by: 'Name',
      },
      isReady: false,
    }
  },
  computed: {
    filteredGuardians () {
      const sortFunc = this.cells.find(cell => cell.name === this.sorting.by).sortFunc
      const sorted = this.$clone(this.guardians).sort(sortFunc)
      return this.sorting.ascending ? sorted : sorted.reverse()
    },
  },
  methods: {
    async getGuardians () {
      this.guardians = (await this.$firestore.collection('users').where('user_type', 'array-contains', 'GUARDIAN').get()).docs.map(doc => doc.data())
      this.isReady = true
    },
    getLocations () {
      return new Promise(async resolve => {
        resolve((await this.$firestore.collection('locations').get()).docs.map(doc => doc.data()))
      })
    },
  },
  async mounted () {
    //this.locations = await this.getLocations()
    this.getGuardians()
  },
}
</script>

<template lang="pug">
  #admin-guardians-main.admin-main
    .admin-guardians-container.admin-container
      .admin-title Parents/Guardians
        .button.pro-button.minor(@click='$modals.show({name: "create-guardian", onSuccess: getGuardians,})') Create Guardian
      .admin-content
        entities-table(
          :entities='filteredGuardians'
          :cells='cells'
          :initialSorting='sorting'
          :isReady='isReady'
          customColumnWidths='136px 180px 250px 140px 100px 100px 100px 150px'
          @onSortingChange='newSorting => sorting = newSorting'
          :tableStyle='{"max-width": "calc(100vw - 400px)"}'
        )
</template>

<style lang="sass" scoped>
  #admin-guardians-main
    .admin-guardians-container
</style>